import React, { h } from "preact";
import {t} from "../../_i18n";
import {Card} from "../../_common/layout";
import {ButtonGhost} from "../../_common/components/buttons/buttons";
import {Section, TextLabel} from "./components";
import {Link} from "react-router-dom";
import AlertBox from "../../_common/components/AlertBox/AlertBox";

export default function BirthDateData({birthDate, linkBirthDate, birthDateRepairStatus}) {

    return (
        <div className='p-left-half sm-no-p-left p-right-half sm-no-p-right'>
            <Card className='m-bottom sm-p-x2-bottom '>
                <div className='font-24 font-medium m-top'>{t('Fecha nacimiento')}</div>
                { (birthDateRepairStatus !== 1) ?
                    <AlertBox type='warning' className='m-top'>{t('birth_date_discrepancy_alert')}</AlertBox>
                :   <AlertBox type='info' className='m-top'>{t('birth_date_discrepancy_info')}</AlertBox>
                }
                <Section className='m-x2-top'>
                    <TextLabel label={t('Fecha nacimiento')} value={birthDate}/>
                    <Link to={linkBirthDate}>
                        <ButtonGhost className='m-top sm-no-m-top full-width sm-no-full-width'>{t('Actualizar')}</ButtonGhost>
                    </Link>
                </Section>
            </Card>
        </div>
    )
}
